/*******************************************************************************
* @license
* Copyright (c) 2016 - present Accedo. All Rights Reserved.
* 
* This source code, its use, and distribution, is subject to the terms
* and conditions of the applicable license agreement.
* 
* VDK Web ProgramGuide Component (@accedo/vdkweb-epg) 7.2.8
* 
*******************************************************************************/
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.timeDiffInMinutes = exports.pixelsToMinutes = exports.msToMinutes = exports.minutesToPixels = void 0;
var _momentMini = _interopRequireDefault(require("moment-mini"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var msToMinutes = function msToMinutes(milliseconds) {
  return _momentMini["default"].duration(milliseconds).asMinutes();
};
exports.msToMinutes = msToMinutes;
var timeDiffInMinutes = function timeDiffInMinutes(startTime, compareTime) {
  var start = (0, _momentMini["default"])(startTime);
  var end = (0, _momentMini["default"])(compareTime);
  var diff = end.diff(start);
  return msToMinutes(diff);
};
exports.timeDiffInMinutes = timeDiffInMinutes;
var minutesToPixels = function minutesToPixels(minutes) {
  var ratio = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 2;
  return minutes * ratio;
};
exports.minutesToPixels = minutesToPixels;
var pixelsToMinutes = function pixelsToMinutes(pixels) {
  var ratio = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 2;
  return pixels / ratio;
};
exports.pixelsToMinutes = pixelsToMinutes;